import { connect } from 'react-redux';
import { isUuid } from '../../../js/app/react/validators';
import View from './LargePurchaseWorkflowView';
import { WORKFLOW_ID } from './LargePurchaseWorkflowConstants';
import {
  reloadAdvizrApplication,
  endOfWorkflowsRedirectTo,
} from '../AdvWorkflow/AdvWorkflowHelpers';
import {
  largePurchaseNameOrDefaultSelector,
  largePurchaseIdOrDefaultSelector,
} from './Steps/ItemDescription/ItemDescriptionSelector';
import {
  supportDataOrEmptyObjectSelector,
  shouldSkipSummaryMultipleGoalsSelector,
} from '../AdvWorkflow/AdvWorkflowSelector';
import { getGoalPageName } from '../../FinancialPlanOPL/Goals/utils/getGoalPageName';
import { GoalTypeDTO } from '../../FinancialPlanOPL/types/goalsDTO';

const mapStateToProps = (state, ownProps) => {
  const workflowAugmentedProps = {
    workflowId: WORKFLOW_ID,
    ...ownProps,
  };
  return {
    ...workflowAugmentedProps,
    itemName: largePurchaseNameOrDefaultSelector(state, workflowAugmentedProps),
    itemId: largePurchaseIdOrDefaultSelector(state, workflowAugmentedProps),
    shouldSkipSummary:
      shouldSkipSummaryMultipleGoalsSelector(state, workflowAugmentedProps) &&
      !supportDataOrEmptyObjectSelector(state, workflowAugmentedProps).BlockAutoOutput,
  };
};

const mapDispatchToProps = () => ({
  outputFunction: (clientId, itemName, itemId) => response => {
    const { ADV } = window;
    reloadAdvizrApplication(true, false, () => {
      const currentClient = ADV.util.getCurrentClient(ADV.data);

      const outputRoute = currentClient.ComponentName || getGoalPageName(GoalTypeDTO.LargePurchase);

      const { Goals: largePurchaseGoals } = response.payload.viewData;

      const goalId =
        itemId ||
        largePurchaseGoals.reduce(
          (goalIdAcc, { Id: id, Earmark: { Name: name } }) => (name === itemName ? id : goalIdAcc),
          null,
        );
      if (!isUuid(goalId)) throw new Error("'payload.viewData.Goal.Id' must be an uuid.");

      const params = {
        clientId,
        goalId,
      };
      endOfWorkflowsRedirectTo(outputRoute, params);
    });
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(View);
